$(function(){
	function showPrice() {
		setTimeout(function(){
			// prices
			document.querySelectorAll('#dateCalendar .ui-datepicker-calendar tbody td').forEach(item => {
				if(item.classList.contains('has-price')) {
					let allPrices = Object.entries(item.classList);
					let price;
					allPrices.forEach(([key, value]) => {
						if(value.includes('price-')) {
							price = value.split('-')[1];
						}
					});
					if(price !== '0') {
						item.innerHTML += '<span class="price">$'+price+'</span>';
					}else {
						item.innerHTML += '<span class="sold-out"> - </span>'; 
					}
				}
			})
			// min-los 
			$('#dateCalendar .ui-datepicker-calendar tbody td').each(function () {
				if($(this).hasClass('has-price')) {
					var results2 = $(this).attr("class").match(/min_los-\d+/i);
					var minlos = results2&&results2.length>0?results2[0].split('-')[1]:'0';
					if($.isNumeric(minlos) && minlos > 0 ) {
						$(this).append(`<span class="min_los">Min. ${minlos} Nights</span>`);
					} else	 {
						$(this).append(`<span class="min_los"> - </span>`);
					}
				}
			});
		},  0);
		// console.log('update prices');
	}

	$.post(site_url + "ajax/functions.php", {
        operation: 'getDayPricesFromTravelTripper',
        hotel_id: 'BAHRHH',
        // rate_code: 'BAR',
        rate_code: '',
        portal_id: 'rockhousehotel',
        number_of_months: 11,
		min_los: 1
    }, function (data) {
        const dataDates = data.dates || [];
        const dataPrices =  data.prices || [];
        const dataMinlos =  data.min_los || [];

		let bookingDateFormat =  document.getElementById('CheckIn--alt').dataset.format;
		let displayDateFormat =  'mm/dd/yy';
		let start, end, op = 0;

		const calendarBeforeShow = date => {
			let dmy = `${date.getFullYear()}-${('0' + (date.getMonth() + 1)).slice(-2)}-${('0' + date.getDate()).slice(-2)}`;
			let index = dataDates.findIndex( x => x==dmy );
			let apiClasses = ( $.inArray(dmy, dataDates) != -1 ) ? `has-price price-${dataPrices[index]} min_los-${dataMinlos[index]}` : '';

			if ( start !== undefined ){
				let startDate = $.datepicker.parseDate(bookingDateFormat, start);
				let endDate = $.datepicker.parseDate(bookingDateFormat, end);;

				if ( date.getTime() == startDate.getTime() ) {
					return[ true, `startday ${apiClasses}` ];
				} else {
					if ( date.getTime() == endDate.getTime() ) {
						return[ true, `endday ${apiClasses}` ];
					} else {
						if( date.getTime() > startDate.getTime() && date.getTime() < endDate.getTime() ){
							return[ true, `days ${apiClasses}` ];
						} else {
							return[ true, apiClasses ];
						}
					}
				}
			} else{
				return [true, apiClasses];
			}
		};

		const calendarOnSelect = date => {
			start = (start !== undefined) ? start : $.datepicker.formatDate(bookingDateFormat, new Date());
			let startDate = $.datepicker.parseDate(bookingDateFormat, start);
			let selectedDate = $.datepicker.parseDate(bookingDateFormat, date);
			
			if ( op === 0 ) {
				op = 1;
				start = date;
				end =  date;  
			} else {
				op = 0;
				if(selectedDate <= startDate){
					end = start;
					start = date;  
				} else {
					end =  date; 
				}
			}

			$('#CheckIn--alt').attr('value',start);
			$('#CheckOut--alt').attr('value',end);

			let startDispaly = $.datepicker.formatDate( displayDateFormat, $.datepicker.parseDate(bookingDateFormat, start) );
			let endDisplay = $.datepicker.formatDate( displayDateFormat, $.datepicker.parseDate(bookingDateFormat, end) );
			$('#CheckInOut').attr('value', `${ startDispaly } - ${ endDisplay }`);

			showPrice();
		};

		const calendarOptions = {
			minDate: 0,
			maxDate: '+11m',
			numberOfMonths: 1,
			dayNamesMin : ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
			dateFormat: bookingDateFormat,
			beforeShowDay: calendarBeforeShow,
			onSelect: calendarOnSelect,
            onChangeMonthYear: function(date) {
                showPrice();
            }
		};
		showPrice();

		$('#dateCalendar').datepicker( calendarOptions );
		$("#CheckInOut").on('keyup', function(){
			const dates = $(this).val().split(' - ');
			$('#CheckIn--alt').val( dates[0] );
			$('#CheckOut--alt').val( dates[1] );
		});
	}, 'json');
});